<div>
  <p-accordion value="">
    <p-accordion-panel value="1">
      <p-accordion-header style="{'background-color': '#7b95a3 !important'}" class="darkHeader">
        <div>
          Filters:
          <span class="mr-4">{{filterDisplay}}</span>
          <span class="float-right">{{totalRecords}} packages</span>
        </div>
      </p-accordion-header>
      <p-accordion-content>
        <div class="grid p-ai-center vertical-container">
          <div class="col-9">
            <div class="grid">
              <div class="col-12">
                <p-select [options]="includeDateFilterOptions" inputSize="40em" [(ngModel)]="includeDateFilterValue" (onChange)="dateFilterChange($event)" optionLabel="label" class="w-56" />
                <span [hidden]="includeDateFilterValue.value == 0">
                  <!---->
                  <p-datepicker id="beginReceivedDate" name="beginReceivedDate" [(ngModel)]="filter.BeginReceivedDate" [style]="{'width':'120px'}" [inputStyle]="{'width':'120px'}" class="margin-left-10"></p-datepicker>
                  -
                  <p-datepicker id="endReceivedDate" name="endReceivedDate" [(ngModel)]="filter.EndReceivedDate" [style]="{'width':'120px'}" [inputStyle]="{'width':'120px'}"></p-datepicker>
                </span>
              </div>
              <div class="col-12">
                Assigned To:
                <p-select [options]="resolveUsers" [(ngModel)]="filter.AssignedTo" (onChange)="assignedToFilterChange()" [style]="{'width':'200px'}"></p-select>
              </div>
            </div>
          </div>
          <div class="col-3">
            <p-button class="pull-right rounded margin-top-20" (click)="applyFilter()" label="  Filter" icon="far fa-filter" iconPos="left"></p-button>
          </div>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
  <!--<p-accordion>
    <p-accordion-panel>
      <p-header>
        Filters:
        <span style="margin-right: 200px;">{{filterDisplay}}</span>
        <span class="float-right">{{totalRecords}} packages</span>
      </p-header>
      <div class="grid p-ai-center vertical-container">
        <div class="col-11">
          <div class="grid">
            <div class="col-12">
              Include packages with Exceptions
            </div>
            <div class="col-12">
              Assigned To:
              <p-select [options]="resolveUsers" [(ngModel)]="filter.AssignedTo" (onChange)="assignedToFilterChange()" [style]="{'width':'200px'}"></p-select>
            </div>
            <div class="col-12">
              <p-checkbox [indeterminate]="true" name="includeDateFilter" inputId="includeDateFilter" (onChange)="dateFilterChange($event)" [(ngModel)]="includeDateFilterValue" class="margin-left-10"></p-checkbox>
              <label for="includeDateFilter" class="ml-2"> {{includeDateFilterLabel}} </label>
              <span [hidden]="!includeDateFilterValue">
                <p-datepicker id="beginReceivedDate" name="beginReceivedDate" [(ngModel)]="filter.BeginReceivedDate" [style]="{'width':'100px'}" [inputStyle]="{'width':'100px'}" class="margin-left-10"></p-datepicker>
                -
                <p-datepicker id="endReceivedDate" name="endReceivedDate" [(ngModel)]="filter.EndReceivedDate" [style]="{'width':'100px'}" [inputStyle]="{'width':'100px'}"></p-datepicker>
              </span>
            </div>
          </div>
        </div>
        <div class="col-1">
          <p-button (click)="applyFilter()" label="Filter" icon="far fa-filter" iconPos="left"></p-button>
        </div>
      </div>
    </p-accordion-panel>
  </p-accordion>-->
</div>

<p-table #packagelist [columns]="cols" [value]="packages" [lazy]="true" (onLazyLoad)="loadPackagesLazy($event)" [paginator]="true"
         [rows]="20" [totalRecords]="totalRecords" [loading]="loading">
  <ng-template pTemplate="caption" [style]="{'height':'30px !important'}">
    <div style="height: 30px; width: 100%">
      <span class="float-left">Package Exception List</span>
      <div class="float-right">
        <input pInputText type="text" (keypress)="handleSearchKey($event, packagelist)" placeholder="Search" [style]="{'margin-right':'15px'}" />
        <a (click)="loadPackagesLazy(null)" class="text-white iconbutton" title="Refresh List"><i class="fa fa-refresh" [ngClass]="{'fa-spin':loading}"></i></a>
        <a *hasClaim="'Resolve_Edit'" [hidden]="processingExceptions " (click)="attemptToResolveRequisitionExceptions()" class="text-white iconbutton" title="Resolve Exceptions"><i class="fal fa-laptop-medical"></i> </a>
        <span [hidden]="!processingExceptions" class="text-white iconbutton"><i class="fas fa-spinner fa-pulse"></i></span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="width:50px">&nbsp;</th>
      <th pSortableColumn="TrackingNumber">Tracking <p-sortIcon field="TrackingNumber"></p-sortIcon></th>
      <th pSortableColumn="FromName">From <p-sortIcon field="FromName"></p-sortIcon></th>
      <th pSortableColumn="ClientName">Client <p-sortIcon field="ClientName"></p-sortIcon></th>
      <th pSortableColumn="ReceivedDate">Received On <p-sortIcon field="ReceivedDate"></p-sortIcon></th>
      <th pSortableColumn="RequisitionCount">Samples <p-sortIcon field="RequisitionCount"></p-sortIcon></th>
      <th pSortableColumn="RequisitionExceptionCount">Exceptions <p-sortIcon field="RequisitionExceptionCount"></p-sortIcon></th>
      <th pSortableColumn="RequisitionRejectCount">Rejects <p-sortIcon field="RequisitionRejectCount"></p-sortIcon></th>
      <th pSortableColumn="ResolveTeamAssignedTo">Assigned <p-sortIcon field="ResolveTeamAssignedTo"></p-sortIcon></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-columns="columns">
    <tr>
      <td>
        <a style="cursor:pointer" (click)="row['showDetail'] = !row['showDetail'];"><i class="fa fa-eye"></i></a>
      </td>
      <td>{{row.TrackingNumber}}</td>
      <td>{{row.FromName}}</td>
      <td>{{row.ClientName}}</td>
      <td>
        {{row.ReceivedDate | date:'short'}}
        <span class="float-right">
          <span class="badge" [ngClass]="row.ReceivedDate | dateAgeBadge">{{row.ReceivedDate | dateAge:'hours'}}</span>
        </span>
      </td>
      <td>{{row.RequisitionCount}}</td>
      <td>{{row.RequisitionExceptionCount}}</td>
      <td>{{row.RequisitionRejectCount}}</td>
      <td>{{row.ResolveTeamAssignedTo}}</td>
    </tr>
    <tr *ngIf="row['showDetail'] == true">
      <td colspan="10" style="background-color: lightgray; padding: 15px">
        <app-receiving-package searchTerm="{{searchTerm}}" packageId="{{row['Id']}}"></app-receiving-package>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-toast></p-toast>
